import {identity} from '@packages/utilities/fp/utils';

export type AssetName = string;

export const name: (arg1: string) => AssetName = identity;

export const nameToString: (arg1: AssetName) => string = identity;
